import * as serviceContext from './serviceContext';
import { BASE_URL_M_ADMIN } from '../config';


let options = {};
let headers = new Headers();
const token = sessionStorage.getItem('token');

headers.append('content-type', 'application/json')
headers.append('Authorization', `${token}`);

options.headers = headers;
options.redirect = 'follow';

export async function encryptData(data) {
    try {
        const response = await serviceContext.post(`${BASE_URL_M_ADMIN}maintenance/encryptdecrypt/encrypt`, JSON.stringify(data), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error
    }
}

export async function decryptData(data) {
    try {
        const response = await serviceContext.post(`${BASE_URL_M_ADMIN}maintenance/encryptdecrypt/decrypt`, JSON.stringify(data), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error
    }
}